export default __webpack_public_path__ + "static/media/rambouillet14.59566b90.jpg";